import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import Copyrights from './Copyrights';
import Links from './Links';

export type ComponentProps = {
  /**
   * Optional wrapper class name attached
   */
  className?: string;
  /**
   * show/hide the element in the page
   */
  showFooter?: boolean;
};

const Wrapper = styled.footer`
  font-size: 0.9375rem;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  background-color: ${colors.darkGrey};

  @media ${device.isTablet} {
    align-items: center;
    font-weight: normal;
  }

  @media ${device.isMobile} {
    font-size: 0.8125rem;
  }
`;

const Info = styled.div`
  padding: 40px 20px;
  border-bottom: 1px solid ${colors.darkGrey75};
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  span:first-child {
    font-weight: 500;
  }

  span:last-child {
    font-weight: normal;
  }

  @media ${device.isTablet}, ${device.isDesktop} {
    display: none;
  }
`;

const Footer: React.FC<ComponentProps> = ({ showFooter, className = '' }) => {
  return !showFooter ? null : (
    <Wrapper className={cx({ [className]: !!className })} role='contentinfo'>
      <Info>
        <span>Service Victoria</span>
        <span>The new place to go for government services</span>
      </Info>
      <Links />
      <Copyrights />
    </Wrapper>
  );
};

export default Footer;
